// // src/components/GraphContainer.js
// import { InformationCircleIcon } from '@heroicons/react/outline';
// import React, { useEffect, useState } from 'react';
// import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
// import { ScaleLoader } from 'react-spinners';

// // Utility function to replace 'NaN' with null for proper chart rendering
// const processData = (dataObj, key, predictedKey, targetKey) => {
//   return dataObj[key]?.map((value, index) => ({
//     name: dataObj.months[index], // X-axis labels (months)
//     actual: isNaN(dataObj[key][index]) ? null : dataObj[key][index],
//     predicted: isNaN(dataObj[predictedKey]?.[index]) ? null : dataObj[predictedKey][index],
//     target: isNaN(dataObj[targetKey]?.[index]) ? null : dataObj[targetKey][index],
//   }));
// };

// // Function to format Y-axis with dollar symbol
// // const formatYAxis = (tick) => {
// //   if (tick >= 1000000) {
// //     return '$' + (tick / 1000000).toFixed(1) + 'M'; // Format numbers greater than 1M
// //   } else if (tick >= 1000) {
// //     return '$' + (tick / 1000).toFixed(1) + 'K'; // Format numbers greater than 1K
// //   }
// //   return '$' + tick; // Return smaller numbers with dollar sign
// // };


// const formatYAxis = (tick) => {
//   if (tick >= 1000000000000) {
//     return '$' + (tick / 1000000000000).toFixed(1) + 'T'; // Trillions
//   } else if (tick >= 1000000000) {
//     return '$' + (tick / 1000000000).toFixed(1) + 'B'; // Billions
//   } else if (tick >= 1000000) {
//     return '$' + (tick / 1000000).toFixed(1) + 'M'; // Millions
//   } else if (tick >= 1000) {
//     return '$' + (tick / 1000).toFixed(1) + 'K'; // Thousands
//   }
//   return tick; // Return smaller numbers as they are
// };

// // Tooltip formatter to show dollar symbol in tooltip
// const tooltipFormatter = (value) => {
//   return `$${value.toLocaleString()}`; // Add dollar symbol and format value with commas
// };

// const GraphContainer = ({ data, lineChartLoading }) => {

//   const [revenueData, setRevenueData] =  useState(null)
//   const [salesData, setSalesData] =  useState(null)
//   const [cogsData, setCogsData] =  useState(null)
  

//   useEffect(() => {
//     if(!lineChartLoading && data) {
//       // const revenueData = processData(data, 'revenueOrg', 'RevenuePredicted', 'revenueTarget');
//       setRevenueData(processData(data, 'revenueOrg', 'RevenuePredicted', 'revenueTarget'))
//       // const salesData = processData(data, 'SalesOrg', 'SalesPredicted', 'SalesTarget');
//       setSalesData(processData(data, 'SalesOrg', 'SalesPredicted', 'SalesTarget'))
//       // const cogsData = processData(data, 'COGSOrg', 'COGSPredicted', 'COGSTarget');
//       setCogsData(processData(data, 'COGSOrg', 'COGSPredicted', 'COGSTarget'))
//     } 
//   }, [lineChartLoading, data])

//   if (!data && !lineChartLoading) return (
//     <div className="flex flex-1 justify-center items-center">
//       <div className="bg-white p-6 rounded-lg shadow-md text-center">
//         <h3 className="text-lg font-semibold text-custom-blue mb-2">Welcome to Financial Forecasting</h3>
//         <p className="text-sm text-slate-500">
//           Follow these steps to generate your financial forecast:
//         </p>
//         <ul className="text-sm text-slate-500 space-y-2 mt-2 text-left">
//           <li><strong>1. What-If:</strong> Start by selecting the What-If parameters and click "Generate Forecast" to begin.</li>
//           <li><strong>2. Adjust Financial Levers:</strong> After fetching the data, modify the values for Sales, COGS, Discounts, etc., using the sliders.</li>
//           <li><strong>3. Generate Forecast:</strong> Once you’ve adjusted the financial levers, click "Generate Forecast" to see the forecast results.</li>
//         </ul>
//       </div>
//     </div>
//   );
  

  

//   // const renderChart = (title, chartData) => (
//   //   <div className="bg-white p-4 shadow-md rounded-lg">
//   //     <p className="font-semibold text-lg mb-2 text-custom-blue">{title}</p>
//   //     <ResponsiveContainer width="100%" height={300}>
//   //       <LineChart data={chartData} margin={{left: 12, right: 10, top: 10}}>
//   //         <CartesianGrid strokeDasharray="3 3" />
//   //         <XAxis dataKey="name" tick={{ fontSize: 14  }} />
//   //         <YAxis tickFormatter={formatYAxis} tick={{ fontSize: 14 }} />
//   //         <Tooltip formatter={tooltipFormatter} />
//   //         <Legend />
//   //         <Line type="monotone" dataKey="actual" stroke="#ff5f3d" strokeOpacity={0.6} dot={{ r: 4 }} />
//   //         <Line type="monotone" dataKey="predicted" stroke="#8c48ff" strokeOpacity={0.8} dot={{ r: 4 }} />
//   //         <Line type="monotone" dataKey="target" stroke="#1664df" strokeOpacity={1} dot={{ r: 4 }} />
//   //       </LineChart>
//   //     </ResponsiveContainer>
//   //   </div>
//   // );

//   const renderChart = (title, chartData) => (
//     <div className="bg-white p-2 shadow-md rounded-lg">
//       <p className="font-semibold text-lg mb-2 text-custom-blue">{title}</p>
//       {lineChartLoading ? (
//         <div className="flex justify-center items-center h-64">
//           <ScaleLoader size={50} color={"#5a8deb"} loading={lineChartLoading} /> {/* Loader component */}
//         </div>
//       ) : (
//         <ResponsiveContainer width="100%" height={300}>
//           <LineChart data={chartData} margin={{ left: 12, right: 10, top: 10 }}>
//             <CartesianGrid strokeDasharray="3 3" />
//             <XAxis dataKey="name" tick={{ fontSize: 14 }} />
//             <YAxis tickFormatter={formatYAxis} tick={{ fontSize: 14 }} />
//             <Tooltip formatter={tooltipFormatter} />
//             <Legend />
//             <Line type="monotone" dataKey="actual" stroke="#ff5f3d" strokeOpacity={0.6} dot={{ r: 4 }} />
//             <Line type="monotone" dataKey="predicted" stroke="#8c48ff" strokeOpacity={0.8} dot={{ r: 4 }} />
//             <Line type="monotone" dataKey="target" stroke="#1664df" strokeOpacity={1} dot={{ r: 4 }} />
//           </LineChart>
//         </ResponsiveContainer>
//       )}
//     </div>
//   );

//   return (
//     <div className="flex-grow p-6 space-y-4 overflow-auto">
//       <div className='flex justify-center space-x-2 items-center mb-2'>
//                         <p className='text-2xl font-bold text-custom-blue'>Financial Forecast Summary</p>
//                         <div className="relative group">
//                             <InformationCircleIcon className="h-6 w-6" />
//                             {/* Tooltip positioned at the bottom, visible only on hover */}
//                             <div className="absolute left-1/2 -translate-x-1/2 top-full mt-2 w-max p-2 z-50 bg-custom-blue text-white text-sm rounded-md opacity-0 group-hover:opacity-100 transition-opacity">
//                             Prophet (Facebook's timeseris additive model) <br />
//                             Linear Regression
//                             </div>
//                         </div>
//                     </div>
//       {/* <p className="flex text-2xl justify-center items-center text-custom-blue font-semibold">
//         Financial Forecast Summary
//       </p> */}
//       <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//         {renderChart("Revenue", revenueData)}
//         {renderChart("Sales", salesData)}
//         {renderChart("COGS", cogsData)}
//       </div>
//     </div>
//   );
// };

// export default GraphContainer;


import { InformationCircleIcon, UploadIcon, DownloadIcon } from '@heroicons/react/outline';
import React, { useEffect, useState } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { ScaleLoader } from 'react-spinners';
import * as XLSX from 'xlsx';
import Loader from './Loader';

// Utility function to replace 'NaN' with null for proper chart rendering
const processData = (dataObj, nameOfChart, key, predictedKey, targetKey) => {
  return dataObj[key]?.map((value, index) => ({
    name: nameOfChart,
    month: dataObj.months[index], // X-axis labels (months)
    actual: isNaN(dataObj[key][index]) ? null : dataObj[key][index],
    predicted: isNaN(dataObj[predictedKey]?.[index]) ? null : dataObj[predictedKey][index],
    target: isNaN(dataObj[targetKey]?.[index]) ? null : dataObj[targetKey][index],
  }));
};

const formatYAxis = (tick) => {
  if (tick >= 1000000000000) return '$' + (tick / 1000000000000).toFixed(1) + 'T';
  else if (tick >= 1000000000) return '$' + (tick / 1000000000).toFixed(1) + 'B';
  else if (tick >= 1000000) return '$' + (tick / 1000000).toFixed(1) + 'M';
  else if (tick >= 1000) return '$' + (tick / 1000).toFixed(1) + 'K';
  return tick;
};

const tooltipFormatter = (value) => `$${value.toLocaleString()}`;

const GraphContainer = ({ data, lineChartLoading }) => {
  const [revenueData, setRevenueData] = useState(null);
  const [salesData, setSalesData] = useState(null);
  const [cogsData, setCogsData] = useState(null);

  useEffect(() => {
    if (!lineChartLoading && data) {
      setRevenueData(processData(data, 'Revenue', 'revenueOrg', 'RevenuePredicted', 'revenueTarget'));
      setSalesData(processData(data, 'Sales', 'SalesOrg', 'SalesPredicted', 'SalesTarget'));
      setCogsData(processData(data, 'COGS', 'COGSOrg', 'COGSPredicted', 'COGSTarget'));
    }
  }, [lineChartLoading, data]);

  // Handle file upload
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const binaryStr = event.target.result;
        const workbook = XLSX.read(binaryStr, { type: 'binary' });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const uploadedData = XLSX.utils.sheet_to_json(sheet);

        // Parse and set the uploaded data to your state
        // Assuming your Excel file has columns: name, actual, predicted, target
        const revenue = []
        const sales = []
        const cogs = []
        uploadedData.forEach((row) => {
          const rowData = {
            ...row,
            actual: row.actual || null,
            predicted: row.predicted || null,
            target: row.target || null,
          }
          if(row?.name === "Revenue") {
            revenue.push(rowData)
          } else if(row?.name === "Sales") {
            sales.push(rowData)
          } else if(row?.name === "COGS") {
            cogs.push(rowData)
          }
        });
        // const parsedData = uploadedData.map((row) => ({
        //   name: row.name,
        //   actual: row.actual || null,
        //   predicted: row.predicted || null,
        //   target: row.target || null,
        // }));

        setRevenueData(revenue); // Example: Updating the revenue data
        setSalesData(sales); // Update other data similarly as needed
        setCogsData(cogs);
      };
      reader.readAsBinaryString(file);
    }
  };

  // Handle file download
  const handleFileDownload = () => {
    console.log('revenueData', revenueData)
    const exportData = [
      ...revenueData,
      ...salesData,
      ...cogsData];
    // const exportData = [
    //   ...revenueData.map(item => ({ name: 'Revenue', ...item })),
    //   ...salesData.map(item => ({ name: 'Sales', ...item, })),
    //   ...cogsData.map(item => ({ name: 'COGS', ...item, }))]; // Combine all data (customize as needed)
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Financial Data');
    XLSX.writeFile(workbook, 'financial_forecast.xlsx');
  };

  if (!data && !lineChartLoading) return (
    <div className="flex flex-1 justify-center items-center">
      <div className="bg-white p-6 rounded-lg shadow-md text-center">
        <h3 className="text-lg font-semibold text-custom-blue mb-2">Welcome to Financial Forecasting</h3>
        <p className="text-sm text-slate-500">
          Follow these steps to generate your financial forecast:
        </p>
        <ul className="text-sm text-slate-500 space-y-2 mt-2 text-left">
          <li><strong>1. What-If:</strong> Start by selecting the What-If parameters and click "Generate Forecast" to begin.</li>
          <li><strong>2. Adjust Financial Levers:</strong> After fetching the data, modify the values for Sales, COGS, Discounts, etc., using the sliders.</li>
          <li><strong>3. Generate Forecast:</strong> Once you’ve adjusted the financial levers, click "Generate Forecast" to see the forecast results.</li>
        </ul>
      </div>
    </div>
  );
  const renderChart = (title, chartData) => (
    <>
      {!lineChartLoading && (
        <div className="bg-white p-2 shadow-md rounded-lg">
          <p className="font-semibold text-lg mb-2 text-custom-blue">{title}</p>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={chartData} margin={{ left: 12, right: 10, top: 10 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" tick={{ fontSize: 14 }} />
              <YAxis tickFormatter={formatYAxis} tick={{ fontSize: 14 }} />
              <Tooltip formatter={tooltipFormatter} />
              <Legend />
              <Line type="monotone" dataKey="actual" stroke="#ff5f3d" strokeOpacity={0.6} dot={{ r: 4 }} />
              <Line type="monotone" dataKey="predicted" stroke="#8c48ff" strokeOpacity={0.8} dot={{ r: 4 }} />
              <Line type="monotone" dataKey="target" stroke="#1664df" strokeOpacity={1} dot={{ r: 4 }} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}
    </>
  );

  return (
    <>
      {lineChartLoading && <Loader isLoading={lineChartLoading} />}
      <div className="flex-grow p-6 space-y-4 overflow-auto">
        {/* Outer container for header and action buttons */}
        <div className="flex justify-between items-center mb-2">
          {/* Centered heading and info icon */}
          <div className="flex-grow flex justify-center items-center space-x-2">
            <p className="text-2xl font-bold text-custom-blue">Financial Forecast Summary</p>
            <div className="relative group">
              <InformationCircleIcon className="h-6 w-6" />
              <div className="absolute left-1/2 -translate-x-1/2 top-full mt-2 w-max p-2 z-50 bg-custom-blue text-white text-sm rounded-md opacity-0 group-hover:opacity-100 transition-opacity">
                Prophet (Facebook's timeseries additive model) <br />
                Linear Regression
              </div>
            </div>
          </div>

          {/* Upload and Download Buttons aligned to the right */}
          <div className="flex items-center space-x-4">
            <label htmlFor="upload-file" title='Upload XLSX' className='cursor-pointer p-2 hover:text-white rounded-full hover:bg-gradient-hover focus:outline-none'>
              <UploadIcon className="h-6 w-6" />
              <input
                id="upload-file"
                type="file"
                accept=".xlsx"
                className="hidden"
                onChange={handleFileUpload}
              />
            </label>
            <button title='Download XLSX' className="p-2 hover:text-white rounded-full hover:bg-gradient-hover focus:outline-none" onClick={handleFileDownload}>
              <DownloadIcon className="h-6 w-6 cursor-pointer" />
            </button>

          </div>
        </div>

        {/* Charts Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {renderChart("Revenue", revenueData)}
          {renderChart("Sales", salesData)}
          {renderChart("COGS", cogsData)}
        </div>
      </div>
    </>
  );
};

export default GraphContainer;



// src/components/GraphContainer.js
// import React from 'react';
// import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

// // Utility function to replace 'NaN' with null for proper chart rendering
// const processData = (dataObj, key, predictedKey, targetKey) => {
//   return dataObj[key]?.map((value, index) => ({
//     name: dataObj.months[index], // X-axis labels (months)
//     actual: isNaN(dataObj[key][index]) ? null : dataObj[key][index],
//     predicted: isNaN(dataObj[predictedKey]?.[index]) ? null : dataObj[predictedKey][index],
//     target: isNaN(dataObj[targetKey]?.[index]) ? null : dataObj[targetKey][index],
//   }));
// };

// const GraphContainer = ({ data }) => {
//   if (!data) return <div className='flex flex-1 justify-center items-center'>
//     <p className='text-sm font-medium text-slate-500'>Click <strong>Go</strong> to see Financial Forecasting</p>
//   </div>;

//   const revenueData = processData(data, 'revenueOrg', 'RevenuePredicted', 'revenueTarget');
//   const salesData = processData(data, 'SalesOrg', 'SalesPredicted', 'SalesTarget');
//   const cogsData = processData(data, 'COGSOrg', 'COGSPredicted', 'COGSTarget');

//   const renderChart = (title, chartData) => (
//     <div className="bg-white p-4 shadow-md rounded-lg">
//       <h3 className="font-semibold mb-2">{title}</h3>
//       <ResponsiveContainer width="100%" height={300}>
//         <LineChart data={chartData}>
//           <CartesianGrid strokeDasharray="3 3" />
//           <XAxis 
//             dataKey="name" 
//             label={{ value: 'Months', position: 'insideBottom', offset: -2 }} // Adjusted label position
//           />
//           <YAxis 
//             // tickFormatter={formatYAxis} 
//             label={{ value: 'Values', angle: -90, position: 'insideLeft', offset: 2 }} // Adjusted label position
//           />
//           <Tooltip />
//           <Legend />
//           <Line type="monotone" dataKey="actual" stroke="#ff5f3d" strokeOpacity={0.6} dot={{ r: 4 }} />
//           <Line type="monotone" dataKey="predicted" stroke="#8c48ff" strokeOpacity={0.8} dot={{ r: 4 }} />
//           <Line type="monotone" dataKey="target" stroke="#1664df" strokeOpacity={1} dot={{ r: 4 }} />
//         </LineChart>
//       </ResponsiveContainer>
//     </div>
//   );

//   return (
//     <div className="flex-grow p-6 space-y-6 overflow-auto">
//       <p className="flex text-2xl justify-center items-center text-custom-blue font-semibold">
//         Financial Forecast Summary
//       </p>
//       <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//         {renderChart("Revenue", revenueData)}
//         {renderChart("Sales", salesData)}
//         {renderChart("COGS", cogsData)}
//       </div>
//     </div>
//   );
// };

// export default GraphContainer;


// src/components/GraphContainer.js
// import React from 'react';
// import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ComposedChart } from 'recharts';

// // Utility function to replace 'NaN' with null for proper chart rendering
// const processData = (dataObj, key, predictedKey, targetKey) => {
//   return dataObj[key]?.map((value, index) => ({
//     name: dataObj.months[index], // X-axis labels (months)
//     actual: isNaN(dataObj[key][index]) ? null : dataObj[key][index],
//     predicted: isNaN(dataObj[predictedKey]?.[index]) ? null : dataObj[predictedKey][index],
//     target: isNaN(dataObj[targetKey]?.[index]) ? null : dataObj[targetKey][index],
//   }));
// };

// // Custom number formatter for Y-axis
// const formatYAxis = (tick) => {
//   if (tick >= 1000000) {
//     return (tick / 1000000).toFixed(1) + 'M'; // Format numbers greater than 1M
//   } else if (tick >= 1000) {
//     return (tick / 1000).toFixed(1) + 'K'; // Format numbers greater than 1K
//   }
//   return tick; // Return smaller numbers as they are
// };

// const GraphContainer = ({ data }) => {
//   if (!data) return <div className='flex flex-1 justify-center items-center'>
//     <p className='text-sm font-medium text-slate-500'>Click <strong>Go</strong> to see Financial Forecasting</p>
//   </div>;

//   const revenueData = processData(data, 'revenueOrg', 'RevenuePredicted', 'revenueTarget');
//   const salesData = processData(data, 'SalesOrg', 'SalesPredicted', 'SalesTarget');
//   const cogsData = processData(data, 'COGSOrg', 'COGSPredicted', 'COGSTarget');

//   const renderChart = (title, chartData) => (
//     <div className="bg-white p-4 shadow-md rounded-lg">
//       <h3 className="font-semibold mb-2 text-center">{title}</h3>
//       <ResponsiveContainer width="100%" height={300}>
//       <ComposedChart
//           width={"100%"}
//           height={"100%"}
//           data={chartData}
//           margin={{
//             top: 15,
//             right: 15,
//             bottom: 15,
//             left: 15,
//           }}
//         >
// {/* <LineChart data={chartData}> */}
//           <CartesianGrid strokeDasharray="3 3" />
//           <XAxis dataKey="name" label={{ value: 'Months', position: 'insideBottomRight', offset: -10 }} />
//           <YAxis type="category" tickFormatter={formatYAxis} label={{ value: 'Values', angle: -90, position: 'insideLeft', offset: -12  }} />
//           <Tooltip />
//           <Legend />
//           <Line type="monotone" dataKey="actual" stroke="#ff5f3d" strokeOpacity={0.6} dot={{ r: 4 }} />
//           <Line type="monotone" dataKey="predicted" stroke="#8c48ff" strokeOpacity={0.8} dot={{ r: 4 }} />
//           <Line type="monotone" dataKey="target" stroke="#1664df" strokeOpacity={1} dot={{ r: 4 }} />
//         {/* </LineChart> */}
//         </ComposedChart>
        
//       </ResponsiveContainer>
//     </div>
//   );

//   return (
//     <div className="flex-grow p-6 space-y-6 overflow-auto">
//       <p className="flex text-2xl justify-center items-center text-custom-blue font-semibold">
//         Financial Forecast Summary
//       </p>
//       <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//         {renderChart("Revenue", revenueData)}
//         {renderChart("Sales", salesData)}
//         {renderChart("COGS", cogsData)}
//       </div>
//     </div>
//   );
// };

// export default GraphContainer;
